import React, { useEffect, useState, useCallback } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, message } from "antd";
import ModalCommon from "../../components/Modal";
import RichTextEditor from "../../components/RichTextEditor";


const SetupRule = () => {
    const [configGame, setConfigGame] = useState();
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    const [term1, setTerm1] = useState('');
    const [term2, setTerm2] = useState('');
    const [term3, setTerm3] = useState('');
    const [term4, setTerm4] = useState('');

    const getDataConfig = useCallback(async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data?.data || res.data;
            const terms = data?.terms || {};
            
            setConfigGame({
                term1: terms?.term1,
                term2: terms?.term2,
                term3: terms?.term3,
                term4: terms?.term4
            });
            
            // Set initial values for editors
            setTerm1(terms?.term1 || '');
            setTerm2(terms?.term2 || '');
            setTerm3(terms?.term3 || '');
            setTerm4(terms?.term4 || '');
        } catch (err) {
            console.log(err);
            messageApi.error("Không thể tải dữ liệu cấu hình");
        }
    }, [messageApi]);

    useEffect(() => {
        getDataConfig();
    }, [getDataConfig]);

    const handleChangeInput = (value, key) => {
        switch (key) {
            case 1: setTerm1(value || ""); return;
            case 2: setTerm2(value || ""); return;
            case 3: setTerm3(value || ""); return;
            case 4: setTerm4(value || ""); return;
            default: return;
        }
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);
            
            const body = {
                config: {
                    terms: {
                        term1: term1,
                        term2: term2,
                        term3: term3,
                        term4: term4,
                    }
                }
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
            setIsShowModalSuccess(true);
            
            // Reload data sau khi update thành công
            setTimeout(() => {
                getDataConfig();
            }, 1000);
        } catch (err) {
            console.log(err);
            messageApi.error(err?.response?.data?.message || "Cập nhật thất bại");
            setIsShowModalSuccess(false);
        }
    };

    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const renderRichTextEditor = (key, defaultValue, changeInput, label, height = 200) => {
        const keyMap = {
            "term1": 1,
            "term2": 2,
            "term3": 3,
            "term4": 4
        };
        
        return (
            <div className="flex w-full items-start" style={{ marginBottom: "32px" }}>
                <div className="flex w-[20%] justify-end mr-10 pt-2">{label}:</div>
                <div className="w-[60%]">
                    <RichTextEditor 
                        value={defaultValue || ''} 
                        onChange={(value) => changeInput(value, keyMap[key])} 
                        placeholder={`Nhập ${String(label || '').toLowerCase()}...`}
                        height={height}
                    />
                </div>
            </div>
        )
    }

    return (
        <div className="col-12">
            {contextHolder}
            {configGame && 
                <div className="col-12">
                    <div className="flex w-full">
                        <div className="flex flex-col w-full items-center justify-center">
                            <div className="col-10 mt-2 flex flex-col items-center justify-center">
                                {renderRichTextEditor(
                                    "term1",
                                    term1, 
                                    handleChangeInput, 
                                    "Thể lệ 1",
                                    200
                                )}

                                {renderRichTextEditor(
                                    "term2",
                                    term2, 
                                    handleChangeInput, 
                                    "Thể lệ 2",
                                    200
                                )}

                                {renderRichTextEditor(
                                    "term3",
                                    term3, 
                                    handleChangeInput, 
                                    "Thể lệ 3",
                                    200
                                )}

                                {renderRichTextEditor(
                                    "term4",
                                    term4, 
                                    handleChangeInput, 
                                    "Thể lệ 4",
                                    200
                                )}
                            </div>
                            <div className="col-10 mt-5 flex items-center justify-center">
                                <Button type="primary" onClick={handleShowModal}>
                                    Cập nhật
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                        getDataConfig();
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                        getDataConfig();
                    }}
                />
            )}
        </div>
    );
};

export default SetupRule;
